import { gql } from '@apollo/client';

export const INTEGRATION_META_INTEGRATION_OVERRIDES_FIELDS = gql`
    fragment IntegrationMetaIntegrationOverridesFields on integration_meta_integration_overrides {
        carrier_id
        config
        created_at
        default_item
        default_order
        integration_integration_overrides_id
        integration_type_id
        last_modified_at
        middle_mile_carrier_id
        override_item
        override_order
        type
    }
`;
